(function () {
  var DISMISS_KEY = "gy-torsion-dismissed";
  var RECOMMEND_KEY = "gy-torsion-recommended";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function fill(template, step) {
    return String(template || "")
      .replace(/\[ideal_min\]/g, String(step.idealMin))
      .replace(/\[ideal_max\]/g, String(step.idealMax))
      .replace(/\[maximum\]/g, String(step.maxBall))
      .replace(/\[tow\]/g, String(step.tow));
  }

  function readNumber(input) {
    if (!input || input.value === "") return null;
    var value = Number(input.value);
    return Number.isFinite(value) ? value : null;
  }

  function hitchForTrailer(steps, index, trailer) {
    var current = steps[index];
    if (!current || !current.stepUp) return null;
    for (var i = index + 1; i < steps.length; i++) {
      if (trailer <= steps[i].tow) return steps[i];
      if (!steps[i].stepUp) return null;
    }
    return null;
  }

  function hitchForBall(steps, index, ball, trailer, direction) {
    var flag = direction > 0 ? "stepUp" : "stepDown";
    var current = steps[index];
    if (!current || !current[flag]) return { step: null, blocked: false };
    var fallback = null;
    var blocked = false;
    for (var i = index + direction; i >= 0 && i < steps.length; i += direction) {
      var leaving = steps[i - direction];
      if (!leaving || !leaving[flag]) break;
      var step = steps[i];
      if (trailer > step.tow) {
        blocked = true;
        if (direction < 0 || !step.stepUp) break;
        continue;
      }
      fallback = step;
      var fits = direction > 0 ? ball <= step.idealMax : ball >= step.idealMin;
      if (fits) return { step: step, blocked: false };
      if (!step[flag]) break;
    }
    return { step: fallback, blocked: blocked && !fallback };
  }

  function init(root) {
    if (!root || root.dataset.gyReady === "true") return;
    var configNode = root.querySelector("[data-gy-torsion-config]");
    if (!configNode) return;
    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      return;
    }
    if (!config || config.current < 0 || !config.steps || !config.steps.length) return;

    root.dataset.gyReady = "true";
    var steps = config.steps;
    var current = steps[config.current];
    var copy = config.copy || {};
    var result = root.querySelector("[data-gy-torsion-result]");
    var ballInput = root.querySelector("[data-gy-ball]");
    var trailerInput = root.querySelector("[data-gy-trailer]");
    var designMode = window.Shopify && window.Shopify.designMode;

    function dismissed() {
      if (designMode) return false;
      try {
        return window.localStorage.getItem(DISMISS_KEY) === "1";
      } catch (error) {
        return false;
      }
    }

    function followedRecommendation() {
      if (designMode) return false;
      try {
        var stored = window.sessionStorage.getItem(RECOMMEND_KEY);
        window.sessionStorage.removeItem(RECOMMEND_KEY);
        return stored !== null && stored !== "" && Number(stored) === Number(config.current);
      } catch (error) {
        return false;
      }
    }

    function neverAgain() {
      try {
        window.localStorage.setItem(DISMISS_KEY, "1");
      } catch (error) {}
      close();
    }

    function open() {
      root.hidden = false;
      document.documentElement.classList.add("gy-torsion-open");
      if (ballInput) ballInput.focus();
    }

    function close() {
      root.hidden = true;
      document.documentElement.classList.remove("gy-torsion-open");
    }

    function link(target, kicker) {
      var wrap = document.createElement("div");
      wrap.className = "gy-torsion__recommend";
      var label = document.createElement("p");
      label.className = "gy-torsion__recommend-label";
      label.textContent = kicker;
      var anchor = document.createElement("a");
      anchor.className = "gy-torsion__link t4s-btn t4s-btn-base t4s-btn-style-default t4s-btn-color-primary t4s-w-100 t4s-justify-content-center t4s-btn-effect-sweep-to-top";
      anchor.href = target.url;
      anchor.textContent = target.title;
      anchor.addEventListener("click", function () {
        try {
          window.sessionStorage.setItem(RECOMMEND_KEY, String(target.index));
        } catch (error) {}
      });
      wrap.appendChild(label);
      wrap.appendChild(anchor);
      return wrap;
    }

    function show(message, target, kicker) {
      result.textContent = "";
      var paragraph = document.createElement("p");
      paragraph.textContent = message;
      result.appendChild(paragraph);
      if (target) result.appendChild(link(target, kicker));
    }

    function advise() {
      var ball = readNumber(ballInput);
      var trailer = readNumber(trailerInput);

      if (ball === null || trailer === null) {
        show(copy.needBoth || "");
        return;
      }

      if (ball > current.idealMax) {
        var higher = hitchForBall(steps, config.current, ball, trailer, 1);
        if (higher.step) {
          show(fill(copy.stepUpText, current), higher.step, copy.stepUpButton);
        } else if (trailer > current.tow) {
          show(fill(copy.towAtTop, current));
        } else {
          show(fill(copy.noLarger, current));
        }
        return;
      }

      if (ball < current.idealMin) {
        var lower = hitchForBall(steps, config.current, ball, trailer, -1);
        if (lower.step) {
          show(fill(copy.stepDownText, current), lower.step, copy.stepDownButton);
        } else if (lower.blocked) {
          show(fill(copy.tooHeavyForSmaller, current));
        } else {
          show(fill(copy.noSmaller, current));
        }
        return;
      }

      if (trailer > current.tow) {
        var fit = hitchForTrailer(steps, config.current, trailer);
        if (fit) {
          show(fill(copy.towStepUp, current), fit, copy.stepUpButton);
        } else {
          show(fill(copy.towAtTop, current));
        }
        return;
      }

      show(fill(copy.inRange, current));
    }

    root.querySelectorAll("[data-gy-close]").forEach(function (button) {
      button.addEventListener("click", close);
    });

    root.querySelectorAll("[data-gy-never]").forEach(function (button) {
      button.addEventListener("click", neverAgain);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !root.hidden) close();
    });

    if (ballInput) ballInput.addEventListener("input", advise);
    if (trailerInput) trailerInput.addEventListener("input", advise);
    advise();

    if (!dismissed() && !followedRecommendation()) open();
  }

  function boot() {
    document.querySelectorAll("[data-gy-torsion]").forEach(init);
  }

  ready(boot);
  document.addEventListener("shopify:section:load", boot);
})();
